import { useFullInfluencer } from "@radarly/core/influencer/use-cases";
import { FullInfluencer } from "@radarly/models/influencer";

export function usePinnedAuthorWidget(
  projectId: number,
  influencerId: string
): { author: FullInfluencer; isLoading: boolean; isError: boolean } {
  const { author, isLoading, isError } = useFullInfluencer(
    projectId,
    influencerId
  );

  return {
    author,
    isLoading,
    isError: isError,
  };
}
